import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getHeaderAdditionalHtml, updateHeaderAdditionalHtml } from '../../../../../redux/methods/menu';
import useFetch from '../../../../../hooks/useFetch';
import { withFormUtils } from '../../../../../hoc/withFormUtils';
import { Form as FinalForm } from 'react-final-form';
import { Container, Form } from 'reactstrap';
import FormFieldTranslationsQuill from '../../../../../components/formFields/FormFieldTranslationsQuill';
import SectionEditFormButtons from '../../../../../components/SectionEditFormButtons';
import { formUtilsHocPropTypes } from '../../../../../propTypes';
import Tabulator from '../../../../../components/Tabulator';

const propTypes =
{
    utils: formUtilsHocPropTypes,
    getFooterSettingsPhotoWithText: PropTypes.func,
    updateFooterSettingsPhotoWithText: PropTypes.func,
    getFooterImage: PropTypes.func,
    updateFooterImage: PropTypes.func,
    forceRefetch: PropTypes.bool,
};

const AdditionalHtml =
(
    {
        utils,
        getHeaderAdditionalHtml,
        updateHeaderAdditionalHtml,
        forceRefetch
    }
) =>
{
    const config = { translations: ['mobile', 'tablet', 'desktop'] };
    const handleOnSubmit = async form =>
    {
        await updateHeaderAdditionalHtml(utils.generateFormToSubmitValues(form, config), false);
    };
    const [ settings ] = useFetch(getHeaderAdditionalHtml, null, [], forceRefetch);
    return settings ? (
        <Container className='px-3' fluid>
            <FinalForm
                initialValues={utils.generateFormInitialValues(settings, config)}
                onSubmit={handleOnSubmit}
                render={({ handleSubmit, form }) => {
                    return (
                        <Form onSubmit={handleSubmit}>
                            <Tabulator
                                listOfElements={[
                                    {
                                        label: 'Mobile',
                                        id: 'mobile',
                                        component: <FormFieldTranslationsQuill
                                                form={form}
                                                utils={utils}
                                                propertyName='mobile'
                                            />
                                    },
                                    {
                                        label: 'Tablet',
                                        id: 'tablet',
                                        component: <FormFieldTranslationsQuill
                                                form={form}
                                                utils={utils}
                                                propertyName='tablet'
                                            />
                                    },
                                    {
                                        label: 'Desktop',
                                        id: 'desktop',
                                        component: <FormFieldTranslationsQuill
                                                form={form}
                                                utils={utils}
                                                propertyName='desktop'
                                            />
                                    },
                                ]}
                            />
                            <SectionEditFormButtons className='px-2' formReset={form.reset} />
                        </Form>
                    );
                }}
            />
        </Container>
    ) : null;
};

AdditionalHtml.propTypes = propTypes;

const mapStateToProps = (state) => ({
    forceRefetch: state.refetchers.bottomMenu,
});

const mapDispatch =
{
    getHeaderAdditionalHtml,
    updateHeaderAdditionalHtml
};

export default withFormUtils(connect(mapStateToProps, mapDispatch)(AdditionalHtml));